import Moment from 'moment';

function dateValidator({ input, msgs, params }) {
  const FORMAT = 'MM/DD/YYYY';
  let maxDate;
  let minDate;

  maxDate = new Moment().add(150, 'years');
  minDate = new Moment().subtract(150, 'years');

  if (params) {
    if (params.min) {
      minDate = new Moment(params.min);
    }

    if (params.max) {
      maxDate = new Moment(params.max);
    }
  }

  const isValidFormat = Moment(input, FORMAT).format(FORMAT) === input;

  if (!isValidFormat) {
    if (msgs && msgs.dateFormat) {
      return msgs.dateFormat;
    }
    return 'Please enter valid date using MM/DD/YYYY format';
  }

  if (!Moment(input, FORMAT).isBefore(maxDate)) {
    return 'Date too far in the past.';
  }

  if (!Moment(input, FORMAT).isAfter(minDate)) {
    return 'Date too far in the future';
  }

  return null;
}

export default dateValidator;
